import type { OpenBizChatSidePaneParams } from 'owa-bizchat-types';

const nonExecutableCmmIds: Set<string> = new Set(['cmm8sfnmv2v', 'cmmdgpzts5s']);

export const isNonExecutableCmmId = (formCode?: OpenBizChatSidePaneParams['formCode']): boolean => {
    return !!formCode && nonExecutableCmmIds.has(formCode);
};
